var map = {
	"./static_box_hover_big.png": 7801,
	"./static_box_hover_big_cn.png": 96068,
	"./static_box_hover_medium.png": 74177,
	"./static_box_hover_medium_cn.png": 11901,
	"./static_box_hover_small.png": 10181,
	"./static_box_hover_small_cn.png": 75244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51104;